'use client'

// src/progress.web.tsx
import * as Progress from "@radix-ui/react-progress";
import * as Slot from "@rn-primitives/slot";
import * as React from "react";
import { View as View2 } from "react-native";
var ProgressContext = React.createContext(null);
var Root2 = React.forwardRef(
  ({ asChild, value, max, getValueLabel, ...props }, ref) => {
    const Component = asChild ? Slot.View : View2;
    return <ProgressContext.Provider value={{ value, max }}><Progress.Root value={value} max={max} getValueLabel={getValueLabel} asChild><Component ref={ref} {...props} /></Progress.Root></ProgressContext.Provider>;
  }
);
Root2.displayName = "RootProgress";
var Indicator2 = React.forwardRef(({ asChild, ...props }, ref) => {
  const Component = asChild ? Slot.View : View2;
  return <Progress.Indicator asChild><Component ref={ref} {...props} /></Progress.Indicator>;
});
Indicator2.displayName = "IndicatorProgress";
export {
  Indicator2 as Indicator,
  Root2 as Root
};
